import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { generateTable } from '../../table/Table';
import { fetchUsers } from '../../../apis';
import { defineKqlQuery } from '../../../helpers';
import { generatePaginationParams, generateSortParams } from '../../../apis/http';
var userQuery = defineKqlQuery().startsWith('username', 'username').startsWith('email', 'email').startsWith('displayName', 'displayName').equals('enabled', 'enabled').equals('spaceAdmin', 'spaceAdmin').end();

var dataSource = function dataSource(_ref) {
  var spaceSlug = _ref.spaceSlug;
  return {
    fn: fetchUsers,
    params: function params(paramData) {
      return [_objectSpread(_objectSpread(_objectSpread({
        spaceSlug: spaceSlug
      }, generateSortParams(paramData)), generatePaginationParams(paramData)), {}, {
        q: userQuery(paramData.filters.toJS()),
        include: 'authorization,details'
      })];
    },
    transform: function transform(result) {
      return {
        data: result.users,
        nextPageToken: result.nextPageToken
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'username',
      label: 'Username',
      type: 'text'
    }, {
      name: 'email',
      label: 'Email',
      type: 'text'
    }, {
      name: 'displayName',
      label: 'Display Name',
      type: 'text'
    }, {
      name: 'enabled',
      label: 'Enabled?',
      type: 'select',
      options: [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }]
    }, {
      name: 'spaceAdmin',
      label: 'Space Admin?',
      type: 'select',
      options: [{
        label: 'Yes',
        value: true
      }, {
        label: 'No',
        value: false
      }]
    }];
  };
};

var BooleanYesNoCell = function BooleanYesNoCell(props) {
  return /*#__PURE__*/React.createElement("td", null, props.value ? 'Yes' : 'No');
};

var columns = [{
  value: 'username',
  title: 'Username',
  sortable: true
}, {
  value: 'email',
  title: 'Email',
  sortable: true
}, {
  value: 'displayName',
  title: 'Display Name',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}, {
  value: 'updatedAt',
  title: 'Updated',
  sortable: true
}, {
  value: 'enabled',
  title: 'Enabled?',
  sortable: false,
  components: {
    BodyCell: BooleanYesNoCell
  }
}, {
  value: 'spaceAdmin',
  title: 'Space Admin?',
  sortable: false,
  components: {
    BodyCell: BooleanYesNoCell
  }
}];
export var UserTable = generateTable({
  tableOptions: ['system', 'spaceSlug'],
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
UserTable.displayName = 'UserTable';